import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterGift' })
export class FilterGiftPipe implements PipeTransform {
    transform(giftList: any[], search: string): any[] {
        if (!search) return giftList;
        const keyword = search.toLowerCase();
        return giftList.filter(gift => gift.label?.toLowerCase().includes(keyword));
    }
}